export type OverlayPlacement = 'left' | 'right' | 'bottom';

export interface OverlayPosition {
  top: number;
  left: number;
  placement: OverlayPlacement;
  iconRect: DOMRect;
}

export function computeCommentOverlayPosition(iconElement: HTMLElement): OverlayPosition | null {
  const iconRect = iconElement.getBoundingClientRect();
  const containerRect = iconElement.getBoundingClientRect();
  const overlayWidth = 320;
  const spacing = 12;
  const margin = 16;

  const top = iconRect.height + spacing;
  let left = Math.max(
    margin - (iconRect.left - containerRect.left),
    Math.min(
      containerRect.width - overlayWidth - (iconRect.left - containerRect.left) - margin,
      iconRect.left - containerRect.left + iconRect.width - overlayWidth,
    ),
  );

  const iconLeftEdge = iconRect.left - containerRect.left;
  const iconRightEdge = iconRect.left - containerRect.left + iconRect.width;
  const overlayRightEdge = left + overlayWidth;
  const overlayLeftEdge = left;

  if (overlayRightEdge > iconRightEdge - 5) {
    left = iconRightEdge - 5 - overlayWidth;
  }

  if (overlayLeftEdge < iconLeftEdge + 5) {
    left = iconLeftEdge + 5;
  }

  return { top, left, placement: 'bottom', iconRect };
}

export function commentOverlayPointerStyle(chatBoxPosition: OverlayPosition) {
  if (chatBoxPosition.placement === 'right') {
    return {
      content: '""',
      position: 'absolute',
      top: 20,
      left: -8,
      width: 0,
      height: 0,
      borderRight: '8px solid white',
      borderTop: '8px solid transparent',
      borderBottom: '8px solid transparent',
    };
  }

  if (chatBoxPosition.placement === 'left') {
    return {
      content: '""',
      position: 'absolute',
      top: 20,
      right: -8,
      width: 0,
      height: 0,
      borderLeft: '8px solid white',
      borderTop: '8px solid transparent',
      borderBottom: '8px solid transparent',
    };
  }

  const pointerLeft = chatBoxPosition.iconRect
    ? `${Math.max(
        Math.min(
          chatBoxPosition.iconRect.left - chatBoxPosition.left + chatBoxPosition.iconRect.width / 2,
          chatBoxPosition.iconRect.left - chatBoxPosition.left + chatBoxPosition.iconRect.width - 5,
        ),
        chatBoxPosition.iconRect.left - chatBoxPosition.left + 5,
      )}px`
    : '50%';

  return {
    content: '""',
    position: 'absolute',
    top: -8,
    left: pointerLeft,
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderBottom: '8px solid white',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
  };
}
